.emptyContainer {
  align-items: center;
}

.emptyDescription {
  margin-top: 16px;
  color: var(--tuna-palette-text-secondary);
}
